var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"display-1 font-weight-bold mx-1 mb-3"},[_vm._v("Authentication Required")]),_c('p',[_vm._v("This feature requires Xero API features")]),_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.requestToken}},[_vm._v(" Xero Authentication ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }